import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import profile_placeholder from "../../assets/images/profile_placeholder.png";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState, store } from "slices/store";
import { persistStore } from "redux-persist";
import { useTranslation } from "react-i18next";

const ProfileDropdown = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { admin } = useSelector((state: RootState) => state.Admin);

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const handleLogout = () => {
    try {
      // Clear tokens from both storages
      sessionStorage.removeItem("token");
      localStorage.removeItem("token");
      
      // Clear remembered email
      localStorage.removeItem("rememberedEmail");
      
      // Clear all sessionStorage (optional, but ensures clean logout)
      sessionStorage.clear();
      
      // Clear Redux persisted state
      persistStore(store).purge();

      // Dispatch logout event for any listeners
      window.dispatchEvent(new Event("logout"));

      // Navigate to login
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Error during logout:", error);
      // Even if there's an error, try to navigate to login
      navigate("/login", { replace: true });
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item"
        style={{ minWidth: "220px" }}
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="btn profile-dropdown-toggle w-100"
        >
          <span className="d-flex align-items-center justify-content-between w-100">
            <span className="d-flex align-items-center">
              <img
                className="rounded-circle header-profile-user"
                src={admin?.profileImage || profile_placeholder}
                alt="Header Avatar"
                style={{ width: "40px", height: "40px" }}
              />
              <div className="d-flex flex-column align-items-start ms-2">
                <span
                  className="fw-medium user-name-text text-muted"
                  style={{
                    fontSize: "11px",
                  }}
                >
                  {t("profile.welcomeBack")}
                </span>
                <span
                  // className="fw-medium user-name-text"
                  style={{
                    fontSize: "15px",
                  }}
                >
                  {`${admin?.firstName} ${admin?.lastName}` || t("profile.admin")}
                </span>
                <span className="fs-13 text-muted user-name-sub-text">
                  {t("profile.admin")}
                </span>
              </div>
            </span>
            <i className="mdi mdi-chevron-down"></i>
          </span>
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-end"
          style={{ minWidth: "220px" }}
        >
          <DropdownItem className="p-0">
            <Link to="/settings" className="dropdown-item">
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">{t("profile.settings")}</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <button
              className="dropdown-item"
              onClick={handleLogout}
              type="button"
            >
              <i className="mdi mdi-logout text-danger fs-16 align-middle me-1 "></i>{" "}
              <span className="align-middle text-danger" data-key="t-logout">
                {t("profile.logout")}
              </span>
            </button>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
